<!-- Container que decide qué versión renderizar según el flujo -->
<app-sales-store-list-v3
  *ngIf="isFlowKrdya"
  (nextStepEvent)="onNextStep()"
  (gotoStepEvent)="gotoStepEvent.emit($event)">
</app-sales-store-list-v3>